import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';

type T = Props & AppStyledProps;

export const RootStyled = styled.div.attrs<T>(() => ({
  className: 'game-endgame-screen',
}))`
  color: white;
  font-size: 16px;
  font-family: Roboto;
  text-align: center;
  position: fixed;
  z-index: 9999;
  width: 100%;
  background-color: #333;

  ${({ backgroundImage }: T) =>
    backgroundImage &&
    `
    background: url(${backgroundImage}) center center/cover no-repeat fixed black;
    height: 100vh !important;
    overflow: auto;
  `}}
`;
